let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dziTX")).then(() => parcelRequire('iLn5v'));